export default __webpack_public_path__ + "static/table_en-065ceff5073679d49d0de37513dc2d54.png";